import { render, staticRenderFns } from "./MailFooter.vue?vue&type=template&id=1b2bf0e3"
import script from "./MailFooter.vue?vue&type=script&lang=js"
export * from "./MailFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports